import type {
  OnInit} from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import type { SubscriptionEntity } from '@ppl/graphql-customer-api';
import { SubscriptionClassification } from '@ppl/graphql-customer-api';
import type { Subscription, UserProfileEntity } from '@ppl/graphql-user-api';
import moment from 'moment';


@Component({
    selector: 'ppl-top-navigation-payment-info',
    templateUrl: './top-navigation-payment-info.component.html',
    styleUrls: ['./top-navigation-payment-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopNavigationPaymentInfoComponent implements OnInit {

  @Input() subscription: Pick<SubscriptionEntity, 'expiredDate' | 'mostDuePaymentDate' | 'classification'>;

  @Output() pay = new EventEmitter<void>();
  @Output() purchase = new EventEmitter<void>();

  Math = Math;

  get showPayment() {
    return Boolean(this.subscription.mostDuePaymentDate);
  }

  get showTier() {
    return (
      !this.subscription.mostDuePaymentDate &&
      this.subscription.classification === SubscriptionClassification.Trial
    );
  }

  get trialEndsInDays() {
    const expiredDate = moment(this.subscription.expiredDate, 'YYYY-MM-DD');
    const today = moment(new Date(), 'YYYY-MM-DD');
    const expiresInDays = Math.ceil(expiredDate.diff(today, 'days', true)) + 1;
    return expiresInDays > 0 ? expiresInDays : 0;
  }

  get paymentDueInDays() {
    const expiredDate = moment(this.subscription.mostDuePaymentDate, 'YYYY-MM-DD');
    const today = moment(new Date(), 'YYYY-MM-DD');
    return Math.ceil(expiredDate.diff(today, 'days', true)) + 1;
  }

  constructor() { }

  ngOnInit() { }

  onPay(event: MouseEvent) {
    this.pay.emit();
  }

  onPurchase(event: MouseEvent) {
    this.purchase.emit();
  }
}


export function canViewPaymentInfoForSubscription(subscription: Subscription, userProfile: UserProfileEntity) {
  const found = subscription.admins.find(
    admin => admin.id === userProfile.id || admin.email === userProfile.email
  );
  return Boolean(found);
}
